import React from "react";
import {
  AppStoreIcon,
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  LogoSVG,
  PlayStoreIcon,
  TikTokIcon,
  TwitterXIcon,
  WhatsappIcon,
  YoutubeIcon,
} from "../icons/Icons";
import { Link } from "react-router-dom";

const footerLinks1 = [
  { name: "الشروط والأحكام", url: "/terms" },
  { name: "سياسات الخصوصية", url: "/privacy-policy" },
  { name: "سياسة ملفات تعريف الارتباط", url: "/cookies-policy" }
];
const footerLinks2 = [
  "تدرب بلا حدود",
  "الدورات التدريبية",
  "الدورات المجانية",
  "المدربين",
  "المدونة",
];

export default function Footer() {
  return (
    <footer className="landing-footer">
      <div className="landing-footer__container">
        <div className="footer-row g-4 g-lg-5">
          {/* Brand + payment */}
          <div className="landing-footer__brand-col">
            <LogoSVG />
            <p className="landing-footer__brand-text">
              منصة تدرب التعليمية للدورات الأون لاين
              <br />
              في الوطن العربي
            </p>

            <p className="landing-footer__payment-label">
              وسائل الدفع عبر تدرب
            </p>
            <div className="landing-footer__payment-icons">
              <img
                src="/images/payment-options/mastercard.png"
                alt="Mada"
                style={{ maxWidth: "100%" }}
              />
              <img
                src="/images/payment-options/visa.png"
                alt="Visa"
                style={{ maxWidth: "100%" }}
              />

              <img
                src="/images/payment-options/knet.png"
                alt="Visa"
                style={{ maxWidth: "100%" }}
              />
              <img
                src="/images/payment-options/paypal.png"
                alt="PayPal"
                style={{ maxWidth: "100%" }}
              />

              <img
                src="/images/payment-options/mada.png"
                alt="Tabby / Tamara"
                style={{ maxWidth: "100%" }}
              />
              <img
                src="/images/payment-options/apple-pay.png"
                alt=""
                style={{ maxWidth: "100%" }}
              />
            </div>

            <p className="landing-footer__app-label">تطبيق تدرب</p>
            <div className="landing-footer__app-links">
              <p>على الأيفون والأندرويد</p>
              <a href="https://play.google.com/store/apps/details?id=com.app.tadarab&hl=en-us" target="_blank">
                <AppStoreIcon />
              </a>
              <a href="https://apps.apple.com/us/app/tadarab/id1587147647" target="_blank">
                <PlayStoreIcon />
              </a>
            </div>
          </div>

          <div className="middle-footer-col">
            {/* Links 1: عن تدرب */}
            <div className="landing-footer__links-col">
              <p className="landing-footer__heading">روابط هامة</p>
              {footerLinks1.map((link, i) => (
                <Link key={link.url} to={link.url} className="landing-footer__link">
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact box */}
          <div className="landing-footer__contact">
            <div className="landing-footer__chat-header">
              <figure>
                <img src="/images/support.jpg" alt="" />
              </figure>
              <div className="landing-footer__chat-bubbles">
                <div className="landing-footer__bubble">
                  <span>أهلاً بك</span>
                  <img
                    src="/images/waving-hand.jpg"
                    alt=""
                    width={20}
                    height={20}
                  />
                </div>
                <div className="landing-footer__bubble">
                  <span>هل لديك سؤال؟</span>
                </div>
              </div>
            </div>

            <p className="landing-footer__contact-text">
              تحتاج مساعدة أو استفسار؟
            </p>

            <a href={`https://wa.me/+96569932303`} target="_blank" className="landing-footer__contact-btn">
              <WhatsappIcon />
              <span>تواصل معنا</span>
            </a>
          </div>
        </div>

        <div className="landing-footer__divider"></div>

        <div className="landing-footer__bottom">
          <div className="landing-footer__copyright">
            جميع الحقوق محفوظة. منصة تدرب. © 2026
          </div>
          <div className="landing-footer__socials">
            <a href="https://www.facebook.com/tadarabonline" target="_blank">
              <FacebookIcon />
            </a>
            <a href="https://www.instagram.com/tadarab/" target="_blank">
              <InstagramIcon />
            </a>
            <a href="https://www.tiktok.com/@tadarab" target="_blank">
              <TikTokIcon />
            </a>
            <a href="https://x.com/tadarab" target="_blank">
              <TwitterXIcon />
            </a>
            <a href="https://www.linkedin.com/company/tadarab/" target="_blank">
              <LinkedInIcon />
            </a>
            <a href="https://www.youtube.com/c/Tadarab" target="_blank">
              <YoutubeIcon />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
